export const infoTooltipText =
  'The Credit Risk Estimate (CRE), is a one-year probability of default. The Credit Risk Level (CRL) indicates a company’s short-term default risk relative to its peers and historical averages.';
